type IconName = "home" | "case" | "book" | "shield" | "search" | "grid" | "menu" | "close" | "clock" | "arrow" | "list" | "up" | "download";

const paths: Record<IconName, string> = {
  home: "M3 11.5 12 4l9 7.5V21h-6v-6H9v6H3z",
  case: "M5 4h14v16H5z M8 2h8v4H8z M9 11h6 M12 8v6",
  book: "M4 4.5A3.5 3.5 0 0 1 7.5 4H12v16H7.5A3.5 3.5 0 0 0 4 20.5z M20 4.5A3.5 3.5 0 0 0 16.5 4H12v16h4.5a3.5 3.5 0 0 1 3.5.5z",
  shield: "M12 3 20 6v6c0 5-3.4 8-8 10-4.6-2-8-5-8-10V6z M12 8v5 M12 17h.01",
  search: "m21 21-4.4-4.4 M10.8 18a7.2 7.2 0 1 1 0-14.4 7.2 7.2 0 0 1 0 14.4",
  grid: "M4 4h6v6H4z M14 4h6v6h-6z M4 14h6v6H4z M14 14h6v6h-6z",
  menu: "M4 7h16 M4 12h16 M4 17h16",
  close: "M5 5l14 14 M19 5 5 19",
  clock: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18 M12 7v5l3 2",
  arrow: "M5 12h14 M14 7l5 5-5 5",
  list: "M8 6h12 M8 12h12 M8 18h12 M4 6h.01 M4 12h.01 M4 18h.01",
  up: "M12 20V5 M6 11l6-6 6 6",
  download: "M12 3v12 M7 10l5 5 5-5 M5 20h14",
};

export function Icon({ name }: { readonly name: string }) {
  const path = paths[name as IconName] ?? paths.arrow;
  return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={path} /></svg>;
}
